exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".miniSearch__searchBar___26KTN{display:block;margin-bottom:5px}.miniSearch__searchBar___26KTN input{width:100%;border-radius:0 6px 6px 0;max-width:none;font-size:12px;padding:10px 15px;height:35px}.miniSearch__searchBar___26KTN button{left:inherit;padding:0;height:33px;font-size:15px;width:49px;right:-2px}.miniSearch__searchBar___26KTN ul li{padding-left:5px!important}.full-box .MiniFundFinder_filters{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.full-box .MiniFundFinder_filters .MiniFundFinder_filterDropdown{width:100%;-ms-flex:0 1 33%;flex:0 1 33%}", ""]);

// exports
exports.locals = {
	"searchBar": "miniSearch__searchBar___26KTN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/MiniFundFinder/overrides/miniSearch.pcss
// module id = 900
// module chunks = 0